module.exports = __webpack_public_path__ + "static/img/carousel_5_nx3ajx_ar_16_9_w_1413.ccd74f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_1413.jpg
// module id = iBo7
// module chunks = 0